<template>
  <div class="m-t-16 m-b-16">
    <!----谈判信息---->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="谈判信息" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="negotiationOptions"
            :el-attrs="{
              size: 'medium',
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:negotiateFileGroupId>
              <upload-authorization-file
                v-if="orderInfo.negotiateFileIds"
                v-model="orderInfo.negotiateFileIds"
                upload-mode="fileId"
                :preview-api="previewPurchaseFileApi"
                :download-api="downloadPurchaseFileApi"
                :translate-data="{
                  downloadTranslate: 'fileUrl'
                }"
                :request-params="{
                  isRelease: true,
                  orderId: orderId
                }"
                :props-data="{
                  disabled: true
                }"
              />
              <span v-else>-</span>
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!---报名供应商信息---->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="报名供应商信息" />
        </div>
        <div class="section-content">
          <div class="info-section">
            <div class="info-section-title">联系人信息</div>
            <jczh-descriptions
              :info="applyInfo"
              :option="applyInfoOption"
              :el-attrs="{
                column: 4,
                labelStyle: {
                  whiteSpace: 'nowrap'
                }
              }"
            />
          </div>

          <div class="info-section">
            <div class="info-section-title">证件</div>
            <template v-if="requireList.length">
              <div
                v-for="item in requireList"
                :key="item.certClassifyId"
                class="flex"
              >
                <i class="el-icon-paperclip"></i>
                <span class="m-l-3 m-r-40">{{ item.certName }}</span>
                <upload
                  :props-data="{
                    uploadMode: 'fileId',
                    fileIdBefore: item.fileId,
                    disabled: true,
                    fileListHiddenControl: {
                      hiddenUploadBtn: true,
                      hiddenFileName: true,
                      hiddenDownloadBtn: true,
                      hiddenPreviewBtn: false
                    }
                  }"
                />
              </div>
            </template>
            <div v-else>暂无数据</div>
          </div>

          <div class="info-section">
            <div class="info-section-title">附件</div>
            <upload
              v-if="applyInfo.applyFileIds"
              :file-id-before.sync="applyInfo.applyFileIds"
              :props-data="{
                uploadMode: 'fileId',
                disabled: true
              }"
            />
            <div v-else>暂无数据</div>
          </div>

          <div class="info-section">
            <div class="info-section-title">其他材料要求</div>
            <other-material-requirements
              v-if="otherRequireValueList.length"
              :table="otherRequireValueList"
              mode="supplier-detail"
              upload-mode="fileId"
            />
            <div v-else>暂无数据</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 报价单信息 -->
    <!-- 同时报价&非密封比价才可查看报价单信息 -->
    <div v-if="isOnceOffer && isNotSeal" class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="报价单信息" />
        </div>
        <div class="section-content">
          <purchase-list-supplier-offer
            :table-data="materialList"
            :item-schema-list="orderInfo.itemSchemaList || []"
            :require-tax="requireTax"
          />

          <!--报价附件--->
          <div class="m-t-20">
            <el-form class="detail-form" label-suffix="：" label-width="110px">
              <el-form-item label="报价附件">
                <span v-if="!quotaInfo.fileGroupId">-</span>
                <upload
                  v-else
                  :props-data="{
                    groupIdBefore: quotaInfo.fileGroupId,
                    disabled: true
                  }"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <!-- 审批历史 -->
    <record-history
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :record-list="flowListing"
    />
  </div>
</template>
<script>
// 组件
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile.vue'
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import PurchaseListSupplierOffer from '@/components/common/PurchaseListComponent/SupplierOffer/index.vue'
import Upload from '@/components/common/Upload/index'
import RecordHistory from '@/components/common/RecordHistory'
import OtherMaterialRequirements from '@/components/common/OtherMaterialRequirements/OtherMaterialRequirements'

// 数据字典
import {
  projectTypeDict,
  releaseMediaDict,
  whetherDict
} from '@/dictionary/project/common'
import { negotiationV2CompareWayDict } from '@/dictionary/project/negotiation-v2'

// api接口
import {
  getNegotiationV2DetailApi,
  previewPurchaseFileApi,
  downloadPurchaseFileApi,
  getNegotiationV2ApplyDetailApi,
  getNegotiationV2QuoteDetailApi
} from '@/api/procure/negotiation-v2'

export default {
  components: {
    UploadAuthorizationFile,
    BaseSectionTitle,
    PurchaseListSupplierOffer,
    Upload,
    RecordHistory,
    OtherMaterialRequirements
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    },

    isByOrderId: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      // 项目信息
      orderInfo: {},

      // 报名响应信息
      applyInfo: {},

      // 报价信息
      quotaInfo: {},
      materialList: []
    }
  },

  computed: {
    orderId() {
      return this.requestQuery.orderId
    },

    applyId() {
      return this.requestQuery.applyId
    },

    // 谈判信息
    negotiationOptions() {
      return [
        { label: '谈判名称', prop: 'orderName', elAttrs: { span: 3 } },
        { label: '采购单位', prop: 'ownerCompanyName' },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value).label || '-'
        },
        {
          label: '发布媒体',
          prop: 'noticeMedium',
          filter: value => {
            const temp = (value || '').split(',')
            return (
              temp
                .map(mediumValue => {
                  return releaseMediaDict.translate(
                    this.orderInfo?.purchaseNotice?.noticeMedium
                  )?.label
                })
                .filter(value => value)
                .join('、') || '-'
            )
          }
        },
        { label: '谈判编号', prop: 'orderCode' },
        {
          label: '谈判地点',
          prop: '',
          filter: value =>
            `${value?.province} - ${value?.city} - ${value?.area}`
        },
        { label: '详细地址', prop: 'address', elAttrs: { span: 2 } },
        {
          label: '谈判文件',
          prop: '',
          slotName: 'negotiateFileGroupId',
          elAttrs: { span: 3 }
        }
      ]
    },

    // 报名供应商
    applyInfoOption() {
      return [
        {
          label: '企业名称',
          prop: 'supplierName',
          elAttrs: { span: 4 }
        },
        {
          label: '联系人姓名',
          prop: 'contactUserName'
        },
        {
          label: '联系人电话',
          prop: 'contactUserPhone'
        },
        {
          label: '联系人邮箱',
          prop: 'contactUserEmail'
        }
      ]
    },

    // 证件
    requireList() {
      return this.applyInfo?.certInfoList || []
    },

    // 其他材料要求
    otherRequireValueList() {
      return (this.applyInfo?.otherRequireValueList || []).map(el => {
        el.content = el.value
        return el
      })
    },

    // 是否同时报价
    isOnceOffer() {
      return this.orderInfo.isOnceOffer === whetherDict.YES.value
    },

    // 报价是否含税
    requireTax() {
      return this.orderInfo?.offerRequireTax === whetherDict.YES.value
    },

    // 比价方式：非密封比价
    isNotSeal() {
      return (
        this.orderInfo.compareType ===
        negotiationV2CompareWayDict.NON_SEALING_COMPARISON.value
      )
    },

    flowListing() {
      const tempList = this.orderInfo?.flowListing || []
      return tempList.filter(item => {
        return (
          item.businessNode === 'signup_approval' &&
          item.customVariables &&
          item.customVariables?.supplierId === this.applyInfo.supplierId
        )
      })
    }
  },

  watch: {
    'requestQuery.orderInfo': {
      handler: function(val) {
        if (val?.orderId) {
          this.orderInfo = this.requestQuery?.orderInfo || {}
          this.getInfo(false)
        }
      },
      immediate: true
    },

    'requestQuery.orderId': {
      handler: function(val) {
        if (this.isByOrderId && val) {
          this.getInfo(true)
        }
      },
      immediate: true
    }
  },

  methods: {
    previewPurchaseFileApi,
    downloadPurchaseFileApi,

    getInfo(isOrderId) {
      const promiseList = isOrderId
        ? [this.getOrderInfo(), this.getApplyDetail()]
        : [this.getApplyDetail()]

      Promise.allSettled(promiseList).then(() => {
        // 同时报价 && 非密封比价
        if (this.isOnceOffer && this.isNotSeal) {
          this.getQuotaInfo()
        }
      })
    },

    /**
     * 获取谈判详情
     */
    getOrderInfo() {
      return getNegotiationV2DetailApi(this.orderId)
        .then(res => {
          const data = res?.data || {}
          const { orderInfo, ...other } = data
          this.orderInfo = { ...orderInfo, ...other }
        })
        .catch(err => {
          console.error('获取谈判详情失败', err)
          this.$message.error(err.message)
        })
    },

    /**
     * 获取报名详情
     */
    getApplyDetail() {
      return getNegotiationV2ApplyDetailApi(this.orderId, this.applyId)
        .then(res => {
          const data = res?.data || {}
          const { apply, ...other } = data
          this.applyInfo = { ...apply, ...other }
        })
        .catch(err => {
          console.error('获取报名详情失败', err)
          this.$message.error(err.message)
        })
    },

    /**
     * 获取报名供应商报价详情
     */
    getQuotaInfo() {
      if (!this.applyInfo?.offerId) return
      getNegotiationV2QuoteDetailApi(this.orderId, this.applyInfo.offerId)
        .then(res => {
          const data = res?.data || {}
          this.quotaInfo = data
          const itemOfferDetailList = data.itemOfferDetailList || []
          this.materialList = itemOfferDetailList.map(el => {
            return {
              ...(el?.itemInfo || {}),
              ...(el.itemOffer || {})
            }
          })
        })
        .catch(err => {
          console.error('获取报价详情失败', err)
          this.$message.error(err.message)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.info-section-title {
  margin-bottom: 24px;
  margin-top: 24px;
  font-size: 16px;
  @include text-bold;
  color: $text-color;
}
</style>
